
import { ResultData } from "@nt-portal/common-sdk";
import { AIPrompt, AIPromptService, PromptRole } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface AIPromptOptions extends ControllerOptions<AIPrompt> {
    tags?: string[];
}



export const createAIPrompt = (item: Partial<AIPrompt>): AIPrompt => {
    return {
    name: item.name ?? "",
    version: item.version ?? "",
    title: item.title ?? "",
    role: item.role ?? PromptRole.SYSTEM,
    promptContent: item.promptContent ?? "",
    executionOrder: item.executionOrder ?? 0,
    serviceName: item.serviceName ?? "",
    createdBy: item.createdBy ?? ""
}
}




export class ClientDocAIPromptService extends BaseClientService implements DataController<AIPrompt> {

    private _service: AIPromptService;


    constructor() {
        super();
        this._service = new AIPromptService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: AIPromptOptions): Promise<ResultData<AIPrompt>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: AIPromptOptions): Promise<ResultData<AIPrompt>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: AIPromptOptions): Promise<AIPrompt | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: AIPromptOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: AIPromptOptions): Promise<AIPrompt | AIPrompt[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: AIPromptOptions): Promise<AIPrompt | AIPrompt[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }



    

}